// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1Dibh","header":"PatientQuestionnaire_header__4_hTq","info":"PatientQuestionnaire_info__1GKVY"};